module.exports = __webpack_public_path__ + "src/img/material_on.666dc21a.svg";